import {CheckInFlowStepBase} from "../common/check-in-flow-step.base";
import {IRoute} from "../../../navigation/models/route.interface";
import {IOnBeforeDeactivationContext} from "../../../../models/wizard/wizard.step.interface";

export class CheckInFlowBoardingPassStep extends CheckInFlowStepBase {
    get title(): string {
        return "Boarding Pass";
    }

    get route(): IRoute {
        return this.routes.boardingPass;
    }

    async next(): Promise<void> {
        await this.services.booking.switchToManageMyBooking();
    }

    protected _shouldAskForConfirmationWhenLeavingBookingFlow(context: IOnBeforeDeactivationContext): boolean {
        return false;
    }

}
